import React from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'semantic-ui-react';
import { addModifiers } from '../../shared/helpers';
import './Flash.css';

const Flash = ({ flashHandler, flashMessages, flashContext, showFlash }) =>
  showFlash && (
    <Portal onClose={flashHandler} open={showFlash}>
      <div className={addModifiers('flash', [flashContext])}>
        <div className="flash__content">
          <div className="flash__header">
            {flashContext === 'error' ? 'Something went wrong!' : 'Success!'}
          </div>
          <ul className="flash__list">
            {flashMessages.map((flashMessage, index) => (
              <li key={String(index)} className="flash__item">
                {flashMessage}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Portal>
  );

Flash.defaultProps = {
  flashMessages: [],
};

Flash.propTypes = {
  flashHandler: PropTypes.func,
  flashMessages: PropTypes.array,
  flashContext: PropTypes.string,
  showFlash: PropTypes.bool,
};

export default Flash;



// WEBPACK FOOTER //
// ./src/components/Flash/Flash.js